<template>
  <div id="payment-methods">
    <!-- <div class="container is-fluid"> -->
    <div class="columns is-flex-direction-column">
      <b-loading v-model="isLoading" :is-full-page="false"></b-loading>
      <div class="column">
        <p class="paymentattention">お支払い情報は3件まで登録可能です。</p>
        <div class="addpayment">
          <div
            class="paymentinfomation"
            v-for="(item, index) in paymentMethods"
            :key="index"
          >
            <div class="paymentcard">
              <div class="card-content">
                <div class="radio-area">
                  <b-radio v-model="usualId" size="is-small" :native-value="item.id" @change.native="changeUsualId"></b-radio>
                  <p class="text">通常利用</p>
                </div>
                <section class="credit-info">
                  <dl class="credit is-clearfix">
                    <dt class="credit__dt">カード番号</dt>
                    <dd class="credit__dd"><span style="margin-right:10px">下4桁</span>{{ item.last4 }}</dd>
                  </dl>
                  <dl class="credit is-clearfix">
                    <dt class="credit__dt">カード名義人</dt>
                    <dd class="credit__dd">{{ item.name }}</dd>
                  </dl>
                  <dl class="credit is-clearfix">
                    <dt class="credit__dt">カード有効期限（月/年）</dt>
                    <dd class="credit__dd">
                      {{ expMonth(item.exp_month) }}/{{ item.exp_year }}
                    </dd>
                  </dl>
                </section>
                <div class="button-area">
                  <b-button class="button" label="削除" @click="onClickDeletePaymentMethod(item.id)"/>
                </div>
              </div>
            </div>
          </div>
          <div class="buttons">
            <b-button class="button" @click="onClickAddPymentMethod" :disabled="paymentMethods.length >= 3">＋支払い方法を追加</b-button>
          </div>
        </div>
      </div>
    </div>
    <!-- </div> -->
  </div>
</template>

<script>
import PaymentMethodFormModal from '@/components/PaymentMethodFormModal';
import * as modal from '@/utils/modal';

export default {
  name: 'PaymentMethods',
  data() {
    return {
      isLoading: true,
      usualId: null,
    };
  },
  computed: {
    paymentMethods() {
      return this.$store.getters['payment/paymentMethods'];
    }
  },
  async created() {
    await this.loadCard();
  },
  methods: {
    async loadCard() {
      this.isLoading = true;
      try {
        await this.$store.dispatch('payment/loadCustomer', {
          userId: this.$store.state.auth.uid,
          email: this.$store.state.auth.email
        });
        this.usualId = this.$store.getters['payment/defaultCardID'];
      } catch (err) {
        console.error(err);
        throw err;
      } finally {
        this.isLoading = false;
      }
    },
    onClickAddPymentMethod() {
      this.$buefy.modal.open({
        parent: this,
        component: PaymentMethodFormModal,
        hasModalCard: true,
        trapFocus: true
      });
    },
    async onClickDeletePaymentMethod(cardId) {

      modal.confirm(this, "",
        `本当に削除してもよろしいですか？この操作は元に戻せません。`,
        null, async () => {
          this.isLoading = true;
          try {
            await this.$store.dispatch('payment/deletePaymentMethod', {
              userId: this.$store.state.auth.uid,
              cardId: cardId
            });
            this.$buefy.toast.open('支払方法を削除しました。');
          } catch (err) {
            console.error(err.message);
            this.$buefy.toast.open({
              duration: 3000,
              message: "削除に失敗しました。",
              type: 'is-danger'
            });
          } finally {
            this.isLoading = false;
          }
        }
      );
      await this.loadCard();
    },
    async changeUsualId(event) {
      let usualId = event.target.value;

      this.isLoading = true;
      try {
        await this.$store.dispatch('payment/changeDefaultCard', usualId);
        return true;
      } catch (err) {
        console.error(err.message);
        this.$buefy.toast.open({
          duration: 3000,
          message: "通常利用カードの変更に失敗しました。",
          type: 'is-danger'
        });
        return false;
      } finally {
        this.isLoading = false;
      }
    },
    expMonth(val) {
      return String(val).padStart(2, "0");
    }
    // onClickEditPaymentMethod(cardId) {
    //   console.log('edit', cardId);
    // }
  }
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/payment-methods.scss';
</style>
